module.exports = __webpack_public_path__ + "img/banner.3b7067b.png";